import { signInWithCustomToken } from 'firebase/auth';
import { auth, identityAuth, isIdentityIntegrationEnabled } from '../firebase';

/**
 * Base URL for Freshmeet HTTPS functions (no trailing slash).
 * Override with REACT_APP_FRESHMEET_FUNCTIONS_URL when needed (e.g. emulator).
 */
export function getFreshmeetFunctionsBaseUrl() {
  const explicit = (process.env.REACT_APP_FRESHMEET_FUNCTIONS_URL || '').trim().replace(/\/$/, '');
  if (explicit) {
    return explicit;
  }
  const pid = process.env.REACT_APP_FIREBASE_PROJECT_ID;
  if (!pid) {
    return '';
  }
  return `https://us-central1-${pid}.cloudfunctions.net`;
}

export function getExchangeIdentitySessionUrl() {
  const base = getFreshmeetFunctionsBaseUrl();
  return base ? `${base}/exchangeIdentitySession` : '';
}

/**
 * After signing in to Fury Identity, obtain a Freshmeet custom token and sign in to domain Auth.
 * @param {import('firebase/auth').Auth} freshmeetAuth - defaults to Freshmeet `auth`
 */
export async function signInFreshmeetAfterIdentity(freshmeetAuth = auth) {
  if (!isIdentityIntegrationEnabled() || !identityAuth) {
    throw new Error('Fury Identity is not configured in this build.');
  }
  const idUser = identityAuth.currentUser;
  if (!idUser) {
    throw new Error('Sign in to Fury Identity first.');
  }
  const idToken = await idUser.getIdToken();
  const url = getExchangeIdentitySessionUrl();
  if (!url) {
    throw new Error('Could not resolve exchangeIdentitySession URL (check REACT_APP_FIREBASE_PROJECT_ID).');
  }
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ idToken }),
  });
  let data = {};
  try {
    data = await res.json();
  } catch {
    data = {};
  }
  if (!res.ok) {
    const msg = (data && data.message) || `Exchange failed (${res.status})`;
    throw new Error(msg);
  }
  if (!data.customToken || typeof data.customToken !== 'string') {
    throw new Error('Invalid response from exchangeIdentitySession.');
  }
  await signInWithCustomToken(freshmeetAuth, data.customToken);
}
